<template>
    <div class="o-tableAddPromoProducts">
        <div
            v-if="products.length"
            class="c-table tableFlex"
            :class="{ '--productSets': isMix }"
        >
            <div class="c-thead">
                <div class="c-td is-5">
                    Zdjęcie w&nbsp;aplikacji
                </div>
                <div class="c-td is-8"></div>
                <div class="c-td is-6"></div>
                <div class="c-td is-1">Nazwa (SKU)</div>
                <div class="c-td is-2">EAN</div>
                <div
                    v-if="
                        isAnyNoEanProduct(products) &&
                            form.step2.merchants.value.length === 1
                    "
                    class="c-td is-3"
                >
                    Kod lokalny
                </div>
                <div class="c-td is-3 gap-0-5">
                    {{
                        isMix
                            ? 'Waga w zestawie'
                            : isTypeWeight &&
                                form.step2.merchants.value.length !== 1
                                ? 'Cena w promocji, kod lokalny'
                                : 'Cena w promocji'
                    }}
                    <a-icon
                        v-if="isTypeWeight"
                        icon="Info"
                        v-tooltip="'Cena za kilogram'"
                    />
                </div>
                <div class="c-td is-4">
                    Cena poza promocją
                </div>
                <div class="c-td is-7"></div>
            </div>
            <div class="c-tbody">
                <product-tree
                    :products="products.slice().reverse()"
                    :product-set="set"
                    :product-set-id="setIdx"
                    component-name="AddNewPromoProduct"
                />
            </div>
        </div>
        <div class="d-flex flex-wrap gap-1 p-3">
            <the-btn
                class="o-tableAddPromoProducts__addProductBtn"
                @click.native="openProductsModal(isMix ? setIdx : undefined)"
            ><a-icon
                class="mr-2"
                icon="Plus"
                height="14px"
                width="14px"
            />Dodaj produkt</the-btn>
            <v-popover>
                <the-btn class="btn-danger" :disabled="isClearProductsDisabled">Usuń wszystkie produkty</the-btn>

                <template slot="popover">
                    <popover-confirm @confirmed="clearForm(2)" />
                </template>
            </v-popover>
        </div>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
import { setTableFlex } from '@/mixins/setTableFlex'

export default {
    mixins: [setTableFlex, addNewPromo],
    props: {
        products: {
            type: Array,
            required: true
        },
        set: {
            type: Object,
            requried: false
        },
        setIdx: {
            type: Number,
            required: false
        },
        clearForm: {
            type: Function
        }
    },

    created() {
        window.addEventListener('scroll', () => {
            this.setTableHeaderFlex()
        })
        window.addEventListener('resize', () => {
            this.setTableMaxHeight()
        })
    },

    watch: {
        products() {
            this.setTableMaxHeight()
        }
    }
}
</script>
